<template>
  <ElFormItem
    :prop="name"
    :label="label"
    :double="doubleWidth"
    class="fi-radiogroup-cont"
  >
    <ElRadioGroup
      v-model="model[name]"
      v-bind="$attrs"
      class="fi-radiogroup"
      :vertical="verticalLayout"
    >
      <slot />
    </ElRadioGroup>

    <HelpIcon :help="help" />
  </ElFormItem>
</template>

<script lang="ts" setup>
/**
 * ### 单选框组件
 * 传入未指定属性会透传到 ElRadioGroup 组件中
 */
import { ElFormItem, ElRadioGroup } from 'element-plus';
import { useShareData } from '../../../core/SharedData';
import HelpIcon from '../../../common/HelpIcon.vue';

const props = defineProps<{
  /**
   * ### post参数名
   */
  name: string;
  /**
   * ### 表单项名
   */
  label: string;
  /**
   * ### 默认值
   */
  defaultValue?: string;
  /**
   * ### 双倍宽度
   */
  double?: boolean;
  /**
   * ### 是否垂直摆放
   */
  vertical?: boolean;
  /**
   * ### 帮助说明
   */
  help?: string;
}>();

const model = useShareData('form', 'model');
// eslint-disable-next-line vue/no-setup-props-destructure
const name = props.name;
if (model[name] === undefined) {
  // eslint-disable-next-line vue/no-setup-props-destructure
  model[name] = props.defaultValue;
}

// 在form中注册
useShareData('form', 'items').$(name)(true);

// 双倍宽度
const doubleWidth = props.double ? '' : undefined;
const verticalLayout = props.vertical ? '' : undefined;
</script>

<style lang="scss" scoped>
.fi-radiogroup[vertical] {
  flex-direction: column;
  align-items: flex-start;
}

.fi-radiogroup[double] {
  grid-column-start: span 2;
}
</style>
